AuthRoute = require 'mixins/authenticated-route'

App.SettingsProfileRoute = Em.Route.extend AuthRoute,
  model: ->
    id = @get('session').get('currentUser.id')
    @store.fetchById('api_user', id)

  actions:
    willTransition: ->
      @get('controller').teardown()
      false
